import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { MASSAASDispatch, MASSAASState } from './store';

export const useMASSAASDispatch = (): MASSAASDispatch =>
  useDispatch<MASSAASDispatch>();
export const useMASSAASSelector: TypedUseSelectorHook<MASSAASState> =
  useSelector;
